const today = () => new Date().toISOString().slice(0, 10);

export const KINDS = {
  reviews: {
    label: "Reviews",
    singular: "review",
    api: "articles",
    type: "review",
    titleKey: "title",
    publicPath: "/reviews",
    defaults: () => articleDefaults("review"),
  },
  guides: {
    label: "Guides",
    singular: "guide",
    api: "articles",
    type: "guide",
    titleKey: "title",
    publicPath: "/guides",
    defaults: () => articleDefaults("guide"),
  },
  comparisons: {
    label: "Comparisons",
    singular: "comparison",
    api: "comparisons",
    titleKey: "title",
    publicPath: "/comparisons",
    defaults: () => ({
      title: "", slug: "", category: "", product_a: "", product_b: "", excerpt: "",
      quick_verdict: "", best_for_a: "", best_for_b: "",
      feature_rows: [{ feature: "", a: "", b: "" }],
      pricing_note: "", strengths_a: [], strengths_b: [], limitations_a: [], limitations_b: [],
      use_cases: [], final_recommendation: "", updated_date: today(), reading_time: 7,
      status: "published", noindex: false,
    }),
  },
  products: {
    label: "Products",
    singular: "product",
    api: "products",
    titleKey: "name",
    publicPath: null,
    defaults: () => ({
      name: "", slug: "", category: "", description: "", long_description: "",
      website_url: "", affiliate_url: "", logo_url: "", logo_initial: "", accent_color: "#3730A3", featured: false,
    }),
  },
  categories: {
    label: "Categories",
    singular: "category",
    api: "categories",
    titleKey: "name",
    publicPath: "/categories",
    defaults: () => ({ name: "", slug: "", intro: "", description: "" }),
  },
};

function articleDefaults(type) {
  return {
    title: "", slug: "", category: "", type, excerpt: "", content: "",
    sections: [{ heading: "", body: "" }],
    author: "SaaSRadarHub Editorial", author_title: "Independent Software Research",
    publication_date: today(), updated_date: today(), reading_time: 6,
    image_url: "", seo_title: "", seo_description: "", related_product_slug: "", featured: false,
    status: "published", noindex: false,
  };
}

const LIST_KEYS = ["strengths_a", "strengths_b", "limitations_a", "limitations_b", "use_cases"];

export function cleanPayload(data) {
  const out = { ...data };
  LIST_KEYS.forEach((k) => {
    if (Array.isArray(out[k])) out[k] = out[k].map((s) => s.trim()).filter(Boolean);
  });
  if (Array.isArray(out.sections))
    out.sections = out.sections.filter((s) => s.heading.trim() || s.body.trim());
  if (Array.isArray(out.feature_rows))
    out.feature_rows = out.feature_rows.filter((r) => r.feature.trim());
  if (out.reading_time !== undefined) out.reading_time = Number(out.reading_time) || 1;
  return out;
}
